export const FilterSVG = (props) => (
  <svg height={13} viewBox="0 0 16 13" width={16} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="m0 2.5h16" stroke="#000" />
      <path d="m0 10.5h16" stroke="#000" />
      <g fill="#000">
        <path d="m12 0h1v5h-1z" />
        <path d="m3 7.973684h1v5h-1z" />
      </g>
    </g>
  </svg>
);
